import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "store";
import AppLoader from "@core/components/appLoader";
import Loader from "@core/helper/Loader";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Router>
      <AppLoader ref={(e) => Loader.setLoader(e)} />
      <App />
    </Router>
  </Provider>
);

reportWebVitals();
